import React from 'react';
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { FormInput, FormMaskedTextBox, FormDropDownList, FormNumericTextBox, FormColorGradient, FormCheckbox, EmailInput, FormTextArea, FormDatePicker } from '../../../../Utils/form-components';
import { Button } from '@progress/kendo-react-buttons';
import { Upload } from '@progress/kendo-react-upload';
import { Loader } from '@progress/kendo-react-indicators';
import { emailValidator } from "../../../../Utils/validators"
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import '../CampaignHome.css'
import { saveCampaigns } from '../../../../Api/CampaignApi';
import { saveCampaignAd, saveCampaignAds } from '../../../../Api/AdsApi';

export default function AddAds(props) {

    const [files, setFiles] = React.useState([]);
    const [image, setImage] = React.useState();

    // Updates the Initial Form with the values from when you select the Address

    const onRemove = (event, formProps) => {
        // Remove the image from the state to display
        setImage(null);
        setFiles(event.newState);

        // clears the logo from the form
        formProps.onChange("logo", {
            value: ""
        });
    };

    const handleChange = (e, formProps, changeItem) => {
        const { name, value } = e.target;
        let updatedValue = value;


        // Check if props and state exist, then update the value if they do **COLORPICKER**
        if (e.target.state?.guid == 'accentColor') {

            if (e.target.state.hex) {
                updatedValue = e.target.state.hex;

                formProps.onChange("accentColor", {
                    value: updatedValue
                });
            }

        } else if (e.affectedFiles) {
            // Handle Logo file upload (assuming e.affectedFiles indicates file change)
            const file = e.affectedFiles[0].getRawFile();

            setImage(file);
            setFiles(e.newState);

            formProps.onChange(changeItem, {
                value: file
                // value: URL.createObjectURL(file)
            });
        } else {
            //Normal handling
            formProps.onChange(changeItem, {
                value: e.target.value.id || e.target.value[changeItem],
            });
        }
    };


    const handleSubmit = async dataItem => {
        try {

            // Loop through each affected file
            const file = files[0];

            // console.log(files);
            // console.log(files[0]);
            // console.log(image);
            let saveData = new FormData();

            saveData.append("Id", 0);
            saveData.append("CampaignId", props.campaignId || 0);

            saveData.append("Body", dataItem.body || "");
            saveData.append("Status", dataItem.active || true);
            saveData.append("files", dataItem.ad || "");
            saveData.append("adsClientId", JSON.parse(localStorage.getItem("userId")) || "");

            // Display the key/value pairs
            for (var pair of saveData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }

            await saveCampaignAd(saveData)
            props.toggleRefresh()
            props.closeDialog()


            props.setAlertMessage("Saved Advertisement")
            props.onTriggerAlert('success')
        } catch (error) {
            props.setAlertMessage(error)
            props.onTriggerAlert('error')

            console.log(error);
        }
    }

    return (
        // !isLoading ?
        <Dialog >
            <Form onSubmit={handleSubmit} render={formRenderProps => <FormElement style={{ padding: "12px", width: "40vw" }}>
                <fieldset className={'k-form-fieldset'} >
                    <div className="form-subheading"> Advertisement</div>
                    <div className='logo-upload' style={{ width: "40vw" }}>
                        {/* TODO:: handle multiple ads images */}
                        {image && <div className="uploaded-preferences-logo"><img src={URL.createObjectURL(image)} alt="Uploaded" /></div>}
                        <Upload
                            defaultFiles={[]}
                            restrictions={{
                                allowedExtensions: [".jpg", ".jpeg", ".png", ".webp", ".gif"],
                            }}
                            accept=".jpg,.jpeg,.png,.webp,.gif"  // Restricts file selection dialog

                            withCredentials={false}
                            saveUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/save'}
                            removeUrl={"https://demos.telerik.com/kendo-ui/service-v4/upload/remove"}
                            multiple={false}
                            files={files}
                            onRemove={(e) => onRemove(e, formRenderProps)}
                            onAdd={(e) => handleChange(e, formRenderProps, "ad")}
                        />
                    </div>

                    <div className='field-wrapper' >
                        <Field style={{ width: '40vw' }} width={"500px"} id={'body'} name={'body'} label={'Body'} component={FormTextArea} />
                    </div>
                    <span className={'k-form-separator'} />

                    <div className="k-form-buttons" style={{ float: "right" }}>
                        <Button
                            themeColor={"primary"}
                            type={"submit"}
                            disabled={!formRenderProps.allowSubmit}
                        >
                            Add Advertisement
                        </Button>
                        <Button onClick={props.closeDialog}>
                            Cancel
                        </Button>
                    </div>
                </fieldset>
            </ FormElement>} />
        </Dialog>

        // : <div className='spinner-wrapper'><Loader className='infinite-spinner' size='large' type='infinite-spinner' /></div>
    )
}